import { render } from "./FormDepartment.vue?vue&type=template&id=118bdbcd"
import script from "./FormDepartment.vue?vue&type=script&lang=js"
export * from "./FormDepartment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__